<template>
  <b-alert
    class="museumscard-card"
    variant="success"
    show
  >
    <b-row>
      <b-col cols="8">
        <strong>{{ $t('details.museumscard.title') }}</strong><br>
        {{ $t('details.museumscard.text1') }}<br>
        {{ $t('details.museumscard.text2') }}<br>
      </b-col>
      <img
        src="@/assets/images/logos/museumscard-2020.png"
        height="100px"
        class="museumscard-logo"
      >
    </b-row>
    <b-row>
      <b-col>
        <a href="https://www.meine-museumscard.de" target="_blank">
          {{ $t('details.museumscard.url') }}
        </a>
      </b-col>
    </b-row>
  </b-alert>
</template>

<script>
export default {
  name: 'MuseumsCard'
}
</script>

<style scoped>
.museumscard-card {
  max-width: 310px;
  margin: auto;
}
.museumscard-logo {
  position: absolute;
  top: -33px;
  right: 0;
}
</style>
